export const CONTRACT_TYPES = [
    { value: "employment", label: "Трудовой договор" },
    { value: "services", label: "Договор оказания услуг" },
    { value: "apprenticeship", label: "Ученический договор" },
];

export const contractTypeLabel = (value) =>
    CONTRACT_TYPES.find((item) => item.value === value)?.label || CONTRACT_TYPES[0].label;
